import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderDownload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderDownload"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H10.4014L12.4014 6H22V20H2V3ZM12 18.0607L8.43934 14.5L9.5 13.4393L11.25 15.1893V10H12.75V15.1893L14.5 13.4393L15.5607 14.5L12 18.0607Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderDownload;
